'use strict';

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');
const Guid=require('pulsar-utils/dist-es6/domain/guid');let

PlotAreaDirective=class PlotAreaDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['timeAxis','height','myself','axisLabelMargins','now','graphBackgroundTop','useReportStyle'];
}

get controller(){
return PlotAreaDirectiveController;
}};let


PlotAreaDirectiveController=class PlotAreaDirectiveController extends BaseResizableDirectiveController{
static get $inject(){
return['$scope','$element','$window','userService'];
}

constructor($scope,$element,$window,userService){
super($scope,$element,$window,userService);

this._id=Guid.create();

this._svgElement=null;
this._userService=userService;
this.myself=this;

this._axes=new Set;
this._plotters=new Set;
this._pastFutureMasks=[{
id:'default-past-future-mask',
futureOpacity:.35},
{
id:'duty-past-future-mask',
futureOpacity:.5}];

}

get id(){
return this._id;
}

registerAxis(axis){
this._axes.add(axis);

if(this._dimensionsValid){
this._updateAxis(axis);
}
}

registerPlotter(plotter){
this._plotters.add(plotter);

if(this._dimensionsValid){
plotter.redraw();
}
}

get svgElement(){
return this._svgElement;
}

get graphAreaDimensions(){
return{
width:this.dimensions.width-(this.axisLabelMargins.left+this.axisLabelMargins.right),
height:this.dimensions.height-(this.axisLabelMargins.top+this.axisLabelMargins.bottom)};

}

get graphAreaBoundaries(){
return{
top:this.axisLabelMargins.top,
left:this.axisLabelMargins.left,
right:this.dimensions.width-this.axisLabelMargins.right,
bottom:this.dimensions.height-this.axisLabelMargins.bottom};

}

_onDimensionsChanged(newDimensions,oldDimensions){
if(_.exists(this._svgElement)){
angular.element(this._svgElement).remove();
}

if(!this._dimensionsValid){
return;
}

for(let axis of this._axes){
this._updateAxis(axis);
}

const nowPosition=_.exists(this.now)?_.clamp(this.timeAxis.scale(this.now.getTime()),0,this.dimensions.width):0;
const graphBackgroundOffset=_.exists(this.graphBackgroundTop)?this.graphBackgroundTop:0;

const useMasks=_.get(this._userService,'currentUser.fatigueMeterType')!==FatigueMeterType.WorkforceAviation;

const htmlForMasks=this._pastFutureMasks.map(mask=>{
return`<mask id="${mask.id}-${this.id}">
                        <rect
                            x="0"
                            y="0"
                            width="${useMasks?nowPosition:this.dimensions.width}"
                            height="${this.dimensions.height}"
                            fill="white"
                            opacity="1">
                        </rect>
                        <rect
                            x="${useMasks?nowPosition:this.dimensions.width}"
                            y="0"
                            width="${useMasks?this.dimensions.width-nowPosition:0}"
                            height="${this.dimensions.height}"
                            opacity="${mask.futureOpacity}"
                            fill="white">
                        </rect>
                    </mask>`;
}).join('\n');

angular.element(this._$element).empty();
this._$element[0].innerHTML=
`<svg width="${this.dimensions.width}" height="${this.dimensions.height}" xmlns="http://www.w3.org/2000/svg" version="1.1">
                <defs>
                    ${this.useReportStyle?sleepCrossHatchMarkup:''}
                    ${htmlForMasks}
                </defs>
                <g class="graph-area-background">
                    <rect
                        x="${this.axisLabelMargins.left}"
                        width="${this.graphAreaDimensions.width}"
                        y="${this.axisLabelMargins.top+graphBackgroundOffset}"
                        height="${this.graphAreaDimensions.height-graphBackgroundOffset}">
                    </rect>
                </g>
            </svg>`;
this._svgElement=this._$element[0].getElementsByTagName('svg')[0];

let widthChanged=newDimensions.width!==oldDimensions.width;
let heightChanged=newDimensions.height!==oldDimensions.height;

for(let plotter of this._plotters){
if(_.exists(plotter.horizontalAxis)&&widthChanged||_.exists(plotter.verticalAxis)&&heightChanged||plotter.alwaysRedraw===!0){
plotter.redraw();
}
}

const svgContainer=d3.select(this._svgElement);
svgContainer.
insert('g','.day-break-lines').
append('rect').
attr({
class:'graph-area-left-margin',
x:0,
width:this.axisLabelMargins.left,
y:this.axisLabelMargins.top+graphBackgroundOffset,
height:this.graphAreaDimensions.height-graphBackgroundOffset});

}

_updateAxis(axis){
switch(axis.orientation){
case'horizontal':
axis.lengthOnScreen=this.graphAreaDimensions.width;
break;
case'vertical':
axis.lengthOnScreen=this.graphAreaDimensions.height;
break;}

}};


const sleepCrossHatchMarkup=`
<pattern id="cross-hatch" patternUnits="userSpaceOnUse" width="8" height="8">
    <image xlink:href="/images/sleepCrossHatch.png" x="0" y="0" width="8" height="8"></image>
</pattern>`;

module.exports=PlotAreaDirective;
//# sourceMappingURL=plotAreaDirective.js.map
